const state = {
  relation: {}
}
const mutations = {
  SET_RELATION: (state, params) => {
    Object.keys(params).forEach(param => {
      state.relation[param] = params[param]
    })
  }
}
const actions = {
  setRelation ({
    commit
  }, param) {
    commit('SET_RELATION', param)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
